export default __webpack_public_path__ + "static/media/49_1_3.646662e3.png";